module.exports = __webpack_public_path__ + "assets/images/header_7f86f9dadb186d7f23184abc9bc88071.jpg";